import { createSlice } from "@reduxjs/toolkit";

const canteenTypeSlice = createSlice({
  name: "canteenType",
  initialState: {
    type: "prepaid", 
  },
  reducers: {
    setCanteenType: (state, action) => {
      state.type = action.payload;
    },
  },
});

export const { setCanteenType } = canteenTypeSlice.actions;
export default canteenTypeSlice.reducer;
